import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const Wrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.md};

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
    padding-bottom: ${({ theme }) => theme.space.md};
  }
`;

export const EndorserLabel = styled(Type)`
  i {
    font-style: italic;
  }
`;

export const EndorsersLogo = styled.img`
  ${(props) => {
    const isHIGN = props["data-endorser-id"] === "hign";
    const width = isHIGN ? "7.25rem" : "14.25rem";
    const height = isHIGN ? "auto" : "4.93rem";

    return `
      width: ${width};
      height: ${height};
    `;
  }}
  object-fit: contain;
  margin-top: ${({ theme }) => theme.space.md};
`;
